import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {UserAppletContainerModel} from "../../../../../models/aggregates/applet-store/user-applet-container.model";
import { ApiVisa, BasicApiResponseModel } from '../shared';


// https://api.akaun.cloud/core2/tnt/dm/applet-login-subject-link/tenant-ep

@Injectable({
  providedIn: 'root'
})
export class UserAppletTenantEpService extends BaseApiTemplateService<UserAppletContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/tenant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/tenant-ep';
    this.httpClient = http;
  }

  tenantAdminGetAppletCount(subjectGuid: string, apiVisa: ApiVisa){
    if(this.endpoint_path && apiVisa.api_domain_url){
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/applet-count/${subjectGuid}`;
    };
    return this.httpClient.get<BasicApiResponseModel<number>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }
}
